// @ts-nocheck
import { HttpClient } from '@angular/common/http';
import { EventEmitter, inject, Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { USER_SERVICE, UserServiceInterface } from '../../../services/user.services';
import {
  ChangeInterceptorPayload,
  Field,
  FieldValue,
  FormControlStructure,
  IFieldControl,
  ISubForm,
  Module,
} from './dynamic-form.model';

@Injectable({
  providedIn: 'root',
})
export class DynamicFormService implements OnDestroy {
  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  public taskId?: string;
  public unlockDynamicFormEmitter = new EventEmitter<boolean>();
  public changeInterceptor = new EventEmitter<ChangeInterceptorPayload>();
  public fieldDependencyInterceptor = new EventEmitter<any>();
  public moduleDependencyInterceptor = new EventEmitter<any>();
  public feedbackEmitter = new EventEmitter<any>();
  public saveEmitter = new EventEmitter<any>();

  public valuesToValidate: any[] = [];

  public getControllFormEmmiter = new EventEmitter<any>();
  public formControlStructureChanged = new EventEmitter<any>();
  public moduleErrorEmitter = new EventEmitter<string>();
  public eventEmitter = new EventEmitter<any>();

  private emmitTimeOut: any = null;
  private _triedSubmit = false;

  public getValuesCompleteToSave = () => {
    return this.valuesCompleteToSave;
  };

  public setPageIniciated = () => {
    this.pageIniciated = true;
  };

  public get triedSubmit(): boolean {
    return this._triedSubmit;
  }
  public set triedSubmit(value: boolean) {
    this._triedSubmit = value;
  }

  private valuesCompleteToSave = {};

  private valueModify = false;

  public pageIniciated = false;

  private valuesToSave: any = {};

  public keyModify: any = null;
  private lastValueModify = null;
  private saveTimeOut: any = null;

  private _formControlStructure: FormControlStructure = new FormControlStructure();
  private http = inject(HttpClient);
  private router = inject(Router);

  public set formControlStructure(value: FormControlStructure) {
    this._formControlStructure = value;
  }
  public get formControlStructure(): FormControlStructure {
    return this._formControlStructure;
  }

  public setFormMetadata(cardInfo: any) {
    this.formControlStructure.formMetadata = cardInfo;
  }
  private structData: any = {};

  public getControllStruct(): any {
    return this.structData;
  }

  /**
   * Translate json subforms template(v1) to the structural spine of the LBCA dynamic form
   * @param subforms Template modules
   */
  public async convertSubformsToControlStructure(subforms: Array<ISubForm>) {
    // PARAMOS AKI EDU
    try {
      if (isArrayAndNotEmpty(subforms)) {
        const formControlStructure: FormControlStructure = this.formControlStructure
          ? this.formControlStructure
          : new FormControlStructure();

        for (const subform of subforms) {
          const { fields: fieldsRow, moduleDependency, id, entityKey } = subform;
          formControlStructure.moduleControl[id] = new Module(id, entityKey);
          const shouldFireAutoSave = subform.type === 'GRIDBOX' ? false : true;
          if (isArrayAndNotEmpty(moduleDependency)) {
            for (const dependency of moduleDependency) {
              let formField = formControlStructure.moduleControl[id];

              formField.moduleLockMessages = new Map<string, string>();
              const { fieldDependency, defaultCondition, lockConditions } = dependency;

              if (isArrayAndNotEmpty(lockConditions)) {
                const overwrite = await this.recursiveScan(
                  lockConditions,
                  formControlStructure.fieldControl,
                  'overwrite'
                );
                formField = { ...formField, ...overwrite };
                formField.locked = !formField.unlocked;
                if (formField.locked) {
                  formField.moduleLockMessages?.set(id, overwrite.msg);
                }
                formControlStructure.moduleControl[id] = formField;
              }

              if (isArrayAndNotEmpty(fieldDependency)) {
                fieldDependency?.forEach((dependencyDefinition) => {
                  const { entityKey } = dependencyDefinition;

                  if (!formControlStructure.moduleDependency[entityKey])
                    formControlStructure.moduleDependency[entityKey] = {};

                  let formModule = formControlStructure.moduleDependency[entityKey][id];
                  formModule = {
                    lockConditions,
                  };
                  formControlStructure.moduleDependency[entityKey][id] = formModule;
                });
              }
            }
          }

          if (isArrayAndNotEmpty(fieldsRow)) {
            for (const fieldsColumn of fieldsRow) {
              for (const field of fieldsColumn) {
                const {
                  entityKey,
                  entityColumnName = false,
                  required,
                  childrenDependency,
                  disabled,
                  entityRecoverKey,
                  mask,
                } = field;

                const entityFieldKey = entityKey;

                formControlStructure.moduleControl[id].fields.push(entityKey);

                formControlStructure.fieldControl[entityFieldKey] = new Field(
                  this,
                  entityFieldKey,
                  required,
                  disabled,
                  mask ? true : false,
                  entityRecoverKey
                );

                formControlStructure.fieldControl[entityFieldKey].shouldFireAutoSave =
                  shouldFireAutoSave;
                const formField = formControlStructure.fieldControl[entityFieldKey];
                formField.fieldLockMessages = new Map<string, string>();

                if (childrenDependency) {
                  const { defaultCondition = {}, father: parents, conditions } = childrenDependency;

                  if (isArrayAndNotEmpty(conditions)) {
                    const overwrite = await this.recursiveScan(
                      conditions,
                      formControlStructure.fieldControl,
                      'overwrite'
                    );
                    for (const key in overwrite) {
                      if (Object.prototype.hasOwnProperty.call(overwrite, key)) {
                        formField[key] = overwrite[key];
                      }
                    }
                    if (formField.locked) {
                      formField.fieldLockMessages?.set(formField.fieldKey, overwrite.msg);
                    }
                    formControlStructure.fieldControl[formField.fieldKey] = formField;
                  }

                  if (isArrayAndNotEmpty(parents)) {
                    formControlStructure.fieldControl[entityFieldKey].parents = parents.map(
                      (parent) => parent.fieldKey
                    );
                    parents.forEach((dependency) => {
                      const { fieldKey } = dependency;
                      if (!formControlStructure.fieldDependency[fieldKey])
                        formControlStructure.fieldDependency[fieldKey] = {};

                      formControlStructure.fieldDependency[fieldKey][field.entityKey] = {
                        conditions,
                        defaultCondition,
                      };

                      Object.keys(defaultCondition).forEach((key) => {
                        formControlStructure.fieldControl[field.entityKey][key] =
                          defaultCondition[key];
                      });
                    });
                  }
                }
              }
            }
          }
          if (subform.type === 'FILE_UPLOAD') {
            const { entityKey, required, disable: disabled, id } = subform;
            const entityFieldKey = entityKey;

            formControlStructure.moduleControl[id].fields.push(entityKey);

            formControlStructure.fieldControl[entityFieldKey] = new Field(
              this,
              entityFieldKey,
              required,
              disabled
            );

            formControlStructure.fieldControl[entityFieldKey].shouldFireAutoSave =
              shouldFireAutoSave;
            const formField = formControlStructure.fieldControl[entityFieldKey];
            formField.fieldLockMessages = new Map<string, string>();
          }
        }
        this.formControlStructure = formControlStructure;
      }
    } catch (error) {
      console.warn(error);
    }
  }

  changeSubscription: Subscription;
  fieldSubscription: Subscription;
  moduleSubscription: Subscription;

  externalData: any;

  constructor() {
    // Mudança de valor em campo
    this.changeSubscription = this.changeInterceptor.subscribe(
      ({ changeSource, id, value }: ChangeInterceptorPayload): void => {
        if (changeSource !== 'firstLoad' && !this.valuesToValidate.some((value) => value === id))
          this.valuesToValidate.push(id);
        const entityKey = id;
        if (this.formControlStructure.fieldControl[entityKey]) {
          this.formControlStructure.fieldControl[entityKey].value = value;
        }
      }
    );

    this.fieldSubscription = this.fieldDependencyInterceptor.subscribe(
      async (localFieldControl: Field) => {
        const { fieldDependency, fieldControl } = this.formControlStructure;
        const { fieldKey } = localFieldControl;

        const shoudReload = false;

        if (fieldDependency[fieldKey]) {
          const dependencyIterator = Object.keys(fieldDependency[fieldKey]);
          for (const dependencyKey of dependencyIterator) {
            const updatingFieldDependency = fieldDependency[fieldKey][dependencyKey];
            const updatingFieldControl = fieldControl[dependencyKey];

            const { conditions } = updatingFieldDependency;

            if (isArrayAndNotEmpty(conditions)) {
              const overwrite = await this.recursiveScan(conditions, fieldControl, 'overwrite');
              if (
                updatingFieldControl.entityRecoverKey &&
                dependencyKey != updatingFieldControl.entityRecoverKey &&
                this.externalData[updatingFieldControl.entityRecoverKey] &&
                overwrite.visible &&
                overwrite.value === undefined
              ) {
                updatingFieldControl['value'] =
                  this.externalData[updatingFieldControl.entityRecoverKey];
              }

              updatingFieldControl.fieldLockMessages?.set(dependencyKey, overwrite?.msg);
              const emit = await this.recursiveScan(conditions, fieldControl, 'emit');
              if (fieldControl[dependencyKey].entityRecoverKey == fieldKey) {
                emit.entityRecoverKey_value = fieldControl[fieldKey].value;
                updatingFieldControl['value'] = fieldControl[fieldKey].value;
              }
              if (emit) {
                const event = new CustomEvent(`reload_${dependencyKey}`, {
                  detail: { ...emit },
                });
                window.dispatchEvent(event);
              }

              Object.keys(overwrite).forEach((key) => (updatingFieldControl[key] = overwrite[key]));
            }

            this.formControlStructure.fieldDependency[fieldKey][dependencyKey] =
              updatingFieldDependency;

            this.formControlStructure.fieldControl[dependencyKey] = updatingFieldControl;
          }

          if (shoudReload) {
            setTimeout(() => {
              this.fieldDependencyInterceptor.next(localFieldControl);
            }, 500);
          }
        }
      }
    );

    this.moduleSubscription = this.moduleDependencyInterceptor.subscribe(
      async (localFieldControl: Field) => {
        const { moduleDependency, moduleControl, fieldControl } = this.formControlStructure;
        const { fieldKey, valid } = localFieldControl;

        let shoudReload = false;

        if (moduleDependency[fieldKey]) {
          const dependencyIterator = Object.keys(moduleDependency[fieldKey]);

          for (const dependencyKey of dependencyIterator) {
            const updatingModuleDependency = moduleDependency[fieldKey][dependencyKey];
            const updatingModuleControl = moduleControl[dependencyKey];

            const { lockConditions } = updatingModuleDependency;

            const overwrite = await this.recursiveScan(lockConditions, fieldControl, 'overwrite');

            shoudReload = updatingModuleControl.locked !== overwrite.locked || shoudReload;

            Object.keys(overwrite).forEach((key) => (updatingModuleControl[key] = overwrite[key]));

            if (updatingModuleControl.locked) {
              updatingModuleControl.moduleLockMessages?.set(dependencyKey, overwrite?.msg);
            } else {
              updatingModuleControl.moduleLockMessages?.delete(dependencyKey);
            }

            this.formControlStructure.moduleDependency[fieldKey][dependencyKey] =
              updatingModuleDependency;
            this.formControlStructure.moduleControl[dependencyKey] = updatingModuleControl;
          }

          if (shoudReload) {
            setTimeout(() => {
              this.fieldDependencyInterceptor.next(localFieldControl);
            }, 500);
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.changeSubscription?.unsubscribe();
    this.fieldSubscription?.unsubscribe();
    this.moduleSubscription?.unsubscribe();
  }

  public getEntityValue(entityKey: string): FieldValue {
    return this.formControlStructure.fieldControl[entityKey].value;
  }

  private startObject = {};

  public setFormControlData =
    (subformId: string) => (entityKey: string, property: string, value: FieldValue) => {
      const props = property == 'propertiesValued' || property == 'startValue' ? 'value' : property; // propertiesValued criado para cortar loop do subform
      if (value !== undefined) {
        if (property == 'startValue') {
          this.startObject[entityKey] = value;
        } else if (property == 'eventEmmiter') {
          this.eventEmitter.emit({ event: entityKey, value });
        } else {
          if (property == 'value') {
            const keys = Object.keys(this.startObject);
            for (const key of keys) {
              if (this.formControlStructure.fieldControl[key]) {
                this.formControlStructure.fieldControl[key].value = this.startObject[key];
                if (!this.formControlStructure.fieldControl[key].disabled)
                  this.formControlStructureChanged.emit(this.formControlStructure);
              }
              delete this.startObject[key];
            }
          }
          if (this.formControlStructure.fieldControl[entityKey]) {
            this.formControlStructure.fieldControl[entityKey][props] = value;

            if (this._triedSubmit && property === 'valid') {
              const moduleId = Object.keys(this.formControlStructure.moduleControl || {}).find(
                (key) => this.formControlStructure.moduleControl[key].fields?.includes(entityKey)
              );

              this.moduleErrorEmitter.emit(moduleId as string);
            }

            if (!this.formControlStructure.fieldControl[entityKey].disabled)
              this.formControlStructureChanged.emit(this.formControlStructure);
          }
        }
      }
    };

  public setGridFormControlData =
    (subformId: string) => (entityKey: string, property: string, value: any) => {
      this.structData[subformId] = {
        ...this.structData[subformId],
        fields: {
          ...(this.structData[subformId] ? this.structData[subformId].fields : {}),
          [entityKey]: {
            ...(this.structData[subformId]
              ? this.structData[subformId].fields[entityKey]
              : {
                  error: [],
                  required: true,
                  value: undefined,
                  valid: false,
                }),
            [property]: value,
          },
        },
      };

      if (property == 'value') {
        if (this.keyModify === entityKey) this.lastValueModify = value;
        this.keyModify = entityKey;
      }

      clearTimeout(this.emmitTimeOut);
      this.emmitTimeOut = setTimeout(() => {
        this.getControllFormEmmiter.emit(this.structData);
        this.valueModify = false;
      }, 200);
    };

  public setTimeOutToSaveData(entityKey, value) {
    if (this.pageIniciated) {
      this.valuesToSave[entityKey] = value;
      this.valuesCompleteToSave[entityKey] = value;
      clearTimeout(this.saveTimeOut);
      this.saveTimeOut = setTimeout(() => {
        this.saveEmitter.emit(this.valuesToSave);
        this.lastValueModify = null;
        this.keyModify = null;
        this.valuesToSave = {};
      }, 500);
    }
  }

  public initializeFieldControlValues(fieldValues: { [x: string]: any }) {
    this.externalData = fieldValues;
    for (const key of Object.keys(fieldValues)) {
      if (
        this.formControlStructure.fieldControl[key] &&
        !this.formControlStructure.fieldControl[key].initialized
      ) {
        this.formControlStructure.fieldControl[key].value = fieldValues[key];
      }
    }

    for (const fieldKey of Object.keys(this.formControlStructure.fieldControl)) {
      if (!this.formControlStructure.fieldControl[fieldKey].value) {
        this.formControlStructure.fieldControl[fieldKey].initialized = true;
      }
    }
  }

  public verifyCapability = async (field, capabilityName: string): Promise<any> => {
    return this.userService.hasCapability(capabilityName);
  };

  operations = {
    equal: (a, b) => booleanToString(a) === booleanToString(b),
    diff: (a, b) => booleanToString(a) !== booleanToString(b),
    isDefault: (a, b) => true,
    isNil: (value) => value === undefined || value === null,
    includes: (dynamicValue: string, templateValue: string[]) =>
      templateValue.includes(dynamicValue),
    excludes: (dynamicValue: string, templateValue: string[]) =>
      !templateValue.includes(dynamicValue),
    capabilty: this.verifyCapability,
  };

  public recursiveScan = async (
    paramterConditions: Array<any>,
    fieldControl: IFieldControl,
    getLeafField: string
  ) => {
    if (isArrayAndNotEmpty(paramterConditions)) {
      for (const condition of paramterConditions) {
        const { field, op, value, property = 'value', conditions } = condition;

        const operation =
          this.operations[op] ||
          function () {
            return false;
          };

        let response;
        try {
          response = await operation(fieldControl[field]?.[property], value);
        } catch (err) {
          response = false;
        }
        if (response) {
          if (isArrayAndNotEmpty(conditions)) {
            const result = await this.recursiveScan(conditions, fieldControl, getLeafField);
            if (Object.keys(result).length !== 0) return result;
          } else {
            return condition[getLeafField] ?? {};
          }
        }
      }
    }
    return {};
  };
}

function isArrayAndNotEmpty(value: any): value is any[] {
  return value && Array.isArray(value) && !!value.length;
}

const booleanToString = (value: any) =>
  typeof value === 'boolean' || value === undefined ? String(value) : value;

// const verifyValueIsNil = (value) => {
//   if (value === undefined || value === null) {
//     return true;
//   }
//   return false;
// };
